// import { Component, ViewChild } from "@angular/core";
// import { AdminService } from "../services/admin.service";
// import { user } from '../models/user';
// import { ActivatedRoute, Router } from "@angular/router";
// import { NgForm } from "@angular/forms";
// import { OnInit } from "@angular/core";
// import { MatSnackBar } from "@angular/material/snack-bar";
// import { LoggerService } from 'src/shared/logger/logger.service';
// import { Levels } from 'src/shared/logger/levels.enum';

// @Component({
//   selector: 'user-edit-component',
//   templateUrl: './user.edit.component.html',
//   styleUrls: ['./user.edit.component.css']
// })
// export class UserEditComponent implements OnInit {
//   user: user = new user();
//   editMode: boolean = false;
//   // activateDeactivateMode: boolean = false;

//   //dropdown list for roles
//   // userRoles: string[] = ['admin', 'operator'];
//   userRoles: string[] = ['admin', 'operator'];

//   @ViewChild('f') editForm: NgForm;
//   constructor(
//     private adminService: AdminService,
//     private activatedRouter: ActivatedRoute,
//     private routingRouter: Router,
//     private _snackBar: MatSnackBar,
//     private loggerService: LoggerService
//   ) {
//   }

//   ngOnInit(): void {
//     this.activatedRouter.url.subscribe(url => {
//       if (url.length > 0) {
//         if (url[0].path == 'new') {
//           this.editMode = false
//           // this.activateDeactivateMode = false;
//         } else if (url[0].path == 'edit') {
//           this.editMode = true;
//           // this.activateDeactivateMode = false;
//           this.adminService.updatedUserID.subscribe(data => {
//             this.getUpdatedUserData(data);
//           });
//         } else {
//           this.editMode = false;
//           // this.activateDeactivateMode = true;
//           this.adminService.updatedUserID.subscribe(data => {
//             this.getUpdatedUserData(data);
//           });
//         }
//       }
//     }, err => {
//       this.loggerService.log("UserEditComponent", err.message, Levels.error)
//     })
//   }

//   insertData(newUser: user) {
//     this.adminService.postUser(newUser).subscribe(data => {
//       this.reloadComponent();
//       this.openSnackBar("User was successfully inserted", "Success");
//       this.loggerService.log("UserEditComponent", 'user inserted successfully', Levels.info)

//     }, err => {
//       this.reloadComponent();
//       this.openSnackBar("Error has occurred try again later", "Error");
//       this.loggerService.log("UserEditComponent", err.message, Levels.error)

//     });
//   }

//   updateData(updatedUser: user) {
//     this.adminService.updateUser(updatedUser).subscribe(data => {
//       this.reloadComponent();
//       this.openSnackBar("User was updated", "Success");
//       this.loggerService.log("UserEditComponent", 'user updated successfully', Levels.info)

//     }, err => {
//       // ("user was not updated. ", err);
//       this.reloadComponent();
//       this.openSnackBar("Error has occurred try again later", "Error");
//       this.loggerService.log("UserEditComponent", err.message, Levels.error)

//     });
//   }



//   onSubmit() {
//     if (this.editForm.valid) {
//       this.user.user_email = this.user.user_email.trim()
//       this.user.user_upn = this.user.user_upn.trim()
//       if (this.editMode) {
//         this.updateData(this.user);
//       } else {
//         this.insertData(this.user);
//       }
//     }
//   }

//   getUpdatedUserData(updatedUserID: number) {
//     if (!updatedUserID) {
//       this.routingRouter.navigate(['admin']);
//       this.openSnackBar("Unauthorized", "Error");
//       return;
//     }
//     this.adminService.getById(updatedUserID).subscribe(data => {
//       this.user = JSON.parse(JSON.stringify(data[0]));
//     }, err => {
//       this.loggerService.log("UserEditComponent", err.message, Levels.error)
//     })
//   }

//   reloadComponent() {
//     this.routingRouter.routeReuseStrategy.shouldReuseRoute = () => false;
//     this.routingRouter.onSameUrlNavigation = 'reload';
//     this.routingRouter.navigate(['/admin']);
//   }

//   openSnackBar(message: string, action: string) {
//     this._snackBar.open(message, action, {
//       duration: 8000,
//       panelClass: ['mat-toolbar', 'mat-primary']
//     });

//   }
// }



//this is the old code


import { Component, ViewChild } from "@angular/core";
import { AdminService } from "../services/admin.service";
import { user } from '../models/user';
import { ActivatedRoute, Router } from "@angular/router";
import { NgForm } from "@angular/forms";
import { OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { LmListsComponent } from 'src/shared/Dialogs/lm-lists/lm-lists.component';
import { MatDialog } from "@angular/material/dialog";
import { folderAccess } from "src/shared/models/folderAccess.model";
import { data } from "jquery";
@Component({
  selector: 'user-edit-component',
  templateUrl: './user.edit.component.html',
  styleUrls: ['./user.edit.component.css']
})
export class UserEditComponent implements OnInit {
  user: user = new user();
  userPassword: string = null;

  editMode: boolean = false;
  resetPasswordMode: boolean = false;
  marketsReceivedIds: number[] = [];
  userEnabled:number = 0;

  //dropdown list for roles
  // userRoles: string[] = ['admin', 'operator'];
  userRoles: string[] = ['admin', 'operator'];

  @ViewChild('f') editForm: NgForm;

  constructor(
    private adminService: AdminService,
    private activatedRouter: ActivatedRoute,
    private routingRouter: Router,
    private _snackBar: MatSnackBar,
    private loggerService: LoggerService,
    private dialog: MatDialog
  ) {
    //console.log(this.user);
  }

  ngOnInit(): void {

    this.activatedRouter.url.subscribe(url => {
      if (url.length > 0) {
        //console.log(url[0].path);
        if (url[0].path == 'new') {
          this.editMode = this.resetPasswordMode = false;
        } else if (url[0].path == 'edit') {
          this.editMode = true;
          this.resetPasswordMode = false;
           this.adminService.updatedUserID.subscribe(data => {
            this.getUpdatedUserData(data);
          });
          this.userEnabled = 0;
          console.log("USER STATUS: ",this.user);
        } else {
          this.editMode = false;
          this.resetPasswordMode = true;
          this.adminService.updatedUserID.subscribe(data => {
            this.getUpdatedUserData(data);
          });
        }
      }
    }, err => {
      //console.log(err);
      this.loggerService.log("UserEditComponent", err.message, Levels.error)
    })
  }

  insertData(newUser: user) {
    this.adminService.postUser(newUser).subscribe(data => {
      this.reloadComponent();
      this.openSnackBar("User was successfully inserted", "Success");
      this.loggerService.log("UserEditComponent", 'user inserted successfully', Levels.info)

    }, err => {
      this.reloadComponent();
      this.openSnackBar("Error has occurred try again later", "Error");
      this.loggerService.log("UserEditComponent", err.message, Levels.error)

    });
  }

  updateData(updatedUser: user) {
    this.adminService.updateUser(updatedUser).subscribe(data => {
      this.reloadComponent();
      this.openSnackBar("User was updated", "Success");
      this.loggerService.log("UserEditComponent", 'user updated successfully', Levels.info)

    }, err => {
      // console.log("user was not updated. ", err);
      this.reloadComponent();
      this.openSnackBar("Error has occurred try again later", "Error");
      this.loggerService.log("UserEditComponent", err.message, Levels.error)

    });
  }

  resetPassword(updatedUser: user) {
    // this.adminService.resetUserPassword(updatedUser.id, this.userPassword).subscribe(data => {
    //   this.reloadComponent();
    //   this.openSnackBar("Password updated successfully", "Success")
    //   this.loggerService.log("UserEditComponent", `updated password for user with id ${updatedUser.id} successfully`, Levels.info)
    // }, err => {
    //   //console.log("user was not updated. ",err);
    //   this.reloadComponent();
    //   this.openSnackBar("Error has occurred try again later", "Error")
    //   this.loggerService.log("UserEditComponent", err.message, Levels.error)
    // });
  }

  onSubmit() {
    if (this.editForm.valid) {
      if (this.editMode) {
        this.updateData(this.user);
      } else if (this.resetPasswordMode) {
        this.resetPassword(this.user);
      } else {
        this.insertData(this.user);
      }
    }
  }

  getUpdatedUserData(updatedUserID: number) {
    if (!updatedUserID) {
      this.routingRouter.navigate(['admin']);
      this.openSnackBar("Unauthorized", "Error");
      return;
    }
    this.adminService.getById(updatedUserID).subscribe(data => {
      this.user = JSON.parse(JSON.stringify(data[0]));
    }, err => {
      //console.log(err);
      this.loggerService.log("UserEditComponent", err.message, Levels.error)
    })
  }

  reloadComponent() {
    this.routingRouter.routeReuseStrategy.shouldReuseRoute = () => false;
    this.routingRouter.onSameUrlNavigation = 'reload';
    this.routingRouter.navigate(['/admin']);
  }


  loadLMSelector(): void {


    const dialogRef = this.dialog.open(LmListsComponent, {
      maxHeight: '100vh',
      data: [],
      disableClose: true,
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        for (let idObj of result) {
          this.marketsReceivedIds.push(idObj.id)
        }
      }
    });

  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });

  }


  validateButton():boolean{
   if (this.editMode){
    // if(!this.editForm.valid) return true;
   }else if(this.resetPassword){
    // if(!this.editForm.valid) return true;
   }else{
    if(this.marketsReceivedIds.length==0) return true;
   }
    return false
  }
}
